import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  uuid: "",
  token: "",
};

export const userSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    onClientReducer: (state, action) => {
      const { uuid, token } = action.payload;
      state.uuid = uuid;
      state.token = token;
    },
  },
});

export const { onClientReducer } = userSlice.actions;
export default userSlice.reducer;
